import React from 'react';
import { Box } from '@twilio-paste/core/box';
import { TrialEnding } from './Banner/TrialEnding';
import { TrialEnded } from './Banner/TrialEnded';
import {
  getWhenTrialEnded,
  formatTrialEndDate,
  getWhenFreeTransitionsToEndOfTrial,
  getWhenTrialTransitionsToEndOfTrial,
  SG_DISCOUNT_FREE_UPGRADE_50_PERCENT_PREFIX,
} from './utils';
import { EmailApiPlan } from 'src/state/types/emailApiPlan';
import { MarketingCampaignsPlan } from 'src/state/types/marketingCampaignsPlan';
import { withTrialBannerConnector } from './Connector';
import { FreeEnding } from './Banner/FreeEnding';

export interface Props {
  emailApiPlan?: EmailApiPlan;
  emailApiFuturePlan?: EmailApiPlan;
  marketingCampaignsPlan?: MarketingCampaignsPlan;
  marketingCampaignsFuturePlan?: MarketingCampaignsPlan;
  discounts: {
    [SG_DISCOUNT_FREE_UPGRADE_50_PERCENT_PREFIX]: boolean;
  };
}

export const TrialNotifications: React.VFC<Props> = ({
  emailApiPlan,
  emailApiFuturePlan,
  marketingCampaignsPlan,
  marketingCampaignsFuturePlan,
  discounts,
}) => {
  if (!emailApiPlan || !marketingCampaignsPlan) {
    return null;
  }

  // Whent the account will move to end of trial (either from free or trial)
  const eiFreeEndingOnDate = getWhenFreeTransitionsToEndOfTrial(
    emailApiPlan,
    emailApiFuturePlan
  );
  const eiTrialEndingOnDate = getWhenTrialTransitionsToEndOfTrial(
    emailApiPlan,
    emailApiFuturePlan
  );
  const mcFreeEndingOnDate = getWhenFreeTransitionsToEndOfTrial(
    marketingCampaignsPlan,
    marketingCampaignsFuturePlan
  );
  const mcTrialEndingOnDate = getWhenTrialTransitionsToEndOfTrial(
    marketingCampaignsPlan,
    marketingCampaignsFuturePlan
  );
  const freeEndingOnDate = eiFreeEndingOnDate || mcFreeEndingOnDate;
  const trialEndingOnDate = eiTrialEndingOnDate || mcTrialEndingOnDate;
  // When the account got put on the end of trial offering (trial or free has ended)
  const eiTrialEndedOnDate = getWhenTrialEnded(emailApiPlan);
  const mcTrialEndedOnDate = getWhenTrialEnded(marketingCampaignsPlan);
  const trialEndedOnDate = eiTrialEndedOnDate || mcTrialEndedOnDate;
  const bothTrialsEnded = eiTrialEndedOnDate && mcTrialEndedOnDate;

  return (
    <Box>
      {bothTrialsEnded && trialEndedOnDate && (
        <TrialEnded trialEndDate={formatTrialEndDate(trialEndedOnDate)} />
      )}
      {trialEndingOnDate && (
        <TrialEnding
          isEiEnding={Boolean(eiTrialEndingOnDate)}
          isMcEnding={Boolean(mcTrialEndingOnDate)}
          trialEndDate={formatTrialEndDate(trialEndingOnDate)}
          hasDiscount={discounts[SG_DISCOUNT_FREE_UPGRADE_50_PERCENT_PREFIX]}
        />
      )}
      {freeEndingOnDate && (
        <FreeEnding
          isEiEnding={Boolean(eiFreeEndingOnDate)}
          isMcEnding={Boolean(mcFreeEndingOnDate)}
          freeEndDate={formatTrialEndDate(freeEndingOnDate)}
          hasDiscount={discounts[SG_DISCOUNT_FREE_UPGRADE_50_PERCENT_PREFIX]}
        />
      )}
    </Box>
  );
};

export default withTrialBannerConnector(TrialNotifications);
